// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { Params } from "./Params";
import { ParamsFromJSON, ParamsFromJSONTyped, ParamsToJSON, ParamsToJSONTyped } from "./Params";

/**
 *
 * @export
 * @interface ScenarioAttachmentCreate
 */
export interface ScenarioAttachmentCreate {
  /**
   *
   */
  type: ScenarioAttachmentCreateTypeEnum;
  /**
   *
   */
  params?: Params | null;
}

/**
 * @export
 */
export const ScenarioAttachmentCreateTypeEnum = {
  _3dTiles: "3d-tiles",
  Buildings: "buildings",
  VulnerableBuildings: "vulnerable-buildings",
} as const;
export type ScenarioAttachmentCreateTypeEnum =
  (typeof ScenarioAttachmentCreateTypeEnum)[keyof typeof ScenarioAttachmentCreateTypeEnum];

/**
 * Check if a given object implements the ScenarioAttachmentCreate interface.
 */
export function instanceOfScenarioAttachmentCreate(
  value: object
): value is ScenarioAttachmentCreate {
  if (!("type" in value) || value["type"] === undefined) return false;
  return true;
}

export function ScenarioAttachmentCreateFromJSON(json: any): ScenarioAttachmentCreate {
  return ScenarioAttachmentCreateFromJSONTyped(json, false);
}

export function ScenarioAttachmentCreateFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): ScenarioAttachmentCreate {
  if (json == null) {
    return json;
  }
  return {
    type: json["type"],
    params:
      json["params"] === undefined
        ? undefined
        : json["params"] === null
        ? null
        : ParamsFromJSON(json["params"]),
  };
}

export function ScenarioAttachmentCreateToJSON(json: any): ScenarioAttachmentCreate {
  return ScenarioAttachmentCreateToJSONTyped(json, false);
}

export function ScenarioAttachmentCreateToJSONTyped(
  value?: ScenarioAttachmentCreate | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    type: value["type"],
    params: ParamsToJSON(value["params"]),
  };
}
